import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { Toaster } from 'sonner'
import { Footer } from '@/components/Footer'
import HomePage from '@/pages/HomePage'
import AuditPage from '@/pages/AuditPage'
import ResultPage from '@/pages/ResultPage'

function App() {
  return (
    <Router>
      <div className="min-h-screen">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/audit" element={<AuditPage />} />
          <Route path="/result" element={<ResultPage />} />
        </Routes>
        <Footer />
        <Toaster position="top-right" />
      </div>
    </Router>
  )
}

export default App
